var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invalid-feedback"},[_vm._l((_vm.error),function(message,index){return (_vm.error && Array.isArray(_vm.error))?_c('span',[_vm._v("\n        "+_vm._s(message)+"\n    ")]):_vm._e()}),_vm._v(" "),(_vm.error && ! Array.isArray(_vm.error))?_c('span',[_vm._v("\n        "+_vm._s(_vm.error)+"\n    ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }